export class ImprovementProposal {
  constructor({
    id,
    relatedProcess,
    improvementGoal,
    currentSituationDescription,
    status,
    creatorUserId,
    trackingUserId,
    createdAt,
    finishedAt,
    rejectionReason,
    relatedDepartments,
    costIncrease,
    timeIncrease,
    costReduction,
    timeReduction,
    documents = [],
    createdByUserName,
    trackingUserName,
  }) {
    this.id = id;
    this.relatedProcess = relatedProcess;
    this.improvementGoal = improvementGoal;
    this.currentSituationDescription = currentSituationDescription;
    this.status = status;
    this.creatorUserId = creatorUserId;
    this.trackingUserId = trackingUserId;
    this.createdAt = createdAt ? new Date(createdAt) : null;
    this.finishedAt = finishedAt ? new Date(finishedAt) : null;
    this.rejectionReason = rejectionReason || null;
    this.relatedDepartments = relatedDepartments;
    this.costIncrease = costIncrease ?? null;
    this.timeIncrease = timeIncrease ?? null;
    this.costReduction = costReduction ?? null;
    this.timeReduction = timeReduction ?? null;
    this.documents = documents;
    this.createdByUserName = createdByUserName || null;
    this.trackingUserName = trackingUserName || null;
  }

  static createFromResponseData(data) {
    return new ImprovementProposal({
      id: data.id,
      relatedProcess: data.relatedProcess,
      improvementGoal: data.improvementGoal,
      currentSituationDescription: data.currentSituationDescription,
      status: data.status,
      creatorUserId: data.creatorUserId,
      trackingUserId: data.trackingUserId,
      createdAt: data.createdAt,
      finishedAt: data.finishedAt,
      rejectionReason: data.rejectionReason,
      relatedDepartments: data.relatedDepartments || [],
      costIncrease: data.costIncrease,
      timeIncrease: data.timeIncrease,
      costReduction: data.costReduction,
      timeReduction: data.timeReduction,
      documents: data.documents || [],
      createdByUserName: data.createdByUserName,
      trackingUserName: data.trackingUserName,
    });
  }
}
